<script setup lang="ts">
import type Popover from 'primevue/popover'

withDefaults(defineProps<{
  title?: string
  showReset?: boolean
}>(), {
  title: 'Instellingen',
  showReset: false,
})

const emit = defineEmits<{
  show: []
  reset: []
}>()

const popover = ref<InstanceType<typeof Popover> | null>(null)

function onToggle(event: Event) {
  popover.value?.toggle(event)
}

function onReset() {
  emit('reset')
}
</script>

<template>
  <div>
    <slot name="trigger" :toggle="onToggle">
      <Button
        v-bind="$attrs"
        outlined
        severity="secondary"
        class="bg-surface-0"
        aria-label="Instellingen"
        @click="onToggle"
      >
        <i class="fa-regular fa-gear mr-2" />
        Instellingen
      </Button>
    </slot>

    <Popover ref="popover" :pt="{ content: 'p-0 overflow-hidden' }" @show="emit('show')">
      <div class="w-76">
        <div class="border-b border-surface-200 px-4 pb-3 pt-4">
          <p class="text-sm text-surface-700 font-semibold">
            {{ title }}
          </p>
        </div>

        <div class="max-h-[28rem] flex flex-col gap-5 overflow-y-auto px-4 py-4">
          <slot />
        </div>

        <div v-if="showReset" class="flex items-center justify-end gap-3 border-t border-surface-200 px-4 py-3">
          <Button
            text
            severity="secondary"
            size="small"
            label="Herstel"
            @click="onReset"
          />
        </div>
      </div>
    </Popover>
  </div>
</template>
